export default __webpack_public_path__ + "static/media/heart.3b8c5628.png";